import { Component, ViewEncapsulation } from '@angular/core';

import { EmailImageAssetDirective } from '../../directives/email-image-asset.directive';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';

@Component({
  selector: 'email-recruitee-logo',
  styleUrls: ['./email-recruitee-logo.component.less'],
  template: `
    <img class="logo" [src]="'assets/recruitee.png'" [width]="148" [height]="44" alt="Recruitee" />
  `,
  imports: [EmailImageAssetDirective, EmailMailgunIfDirective],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class EmailRecruiteeLogoComponent {}
